import { useState } from "react";
import { useTelegram } from "../../contexts/TelegramContext";
import TgLista from "./TgLista";
import TgConversacion from "./TgConversacion";
import ConectarTelegram from "./ConectarTelegram";
import QuienVeQue from "./QuienVeQue";

/** Avisos cuando no hay chats que mostrar (apagado, sin conectar, sin acceso). Devuelve null si todo está listo para leer. El cuerpo no usa hooks. */
export function estadoTelegram(t) {
  const { carga, status } = t;
  if (carga === "cargando") return <div className="tg-estado" data-testid="tg-cargando-estado">Cargando Telegram…</div>;
  if (carga === "apagado") return <div className="tg-estado" data-testid="tg-apagado"><b>Telegram está apagado</b><span>El módulo no está activado en este servidor. Cuando se encienda, aquí aparecerán tus chats.</span></div>;
  if (carga === "error" || !status) {
    return <div className="tg-estado" data-testid="tg-error-estado"><b>No se pudo consultar Telegram</b><button type="button" className="tg-btn" onClick={() => t.refreshStatus()}>Reintentar</button></div>;
  }
  if (status.state === "sin_acceso") {
    return <div className="tg-estado" data-testid="tg-sin-acceso"><b>No tienes chats autorizados</b><span>{status.role === "none" ? "Tu cuenta no tiene un Telegram propio en Commandix. Cada gerente (y el Founder) conecta el suyo." : "Nadie te ha concedido chats todavía. Pídele al gerente que te autorice en «Quién ve qué»."}</span></div>;
  }
  if (status.role === "owner" && !["conectado", "modo_lectura"].includes(status.state)) return <ConectarTelegram />;
  if (status.role === "employee" && status.state === "sin_conectar") {
    return <div className="tg-estado" data-testid="tg-owner-desconectado"><b>La cuenta de Telegram del gerente no está conectada</b><span>Cuando la vuelva a conectar, verás de nuevo los chats que te autorizó.</span></div>;
  }
  return null;
}

/** El Chat con Telegram completo: lista + conversación, calcado de Telegram Web «A» (referencia real del Founder):
 * tarjeta blanca flotante de la lista (con sus pestañas de carpeta en píldora) sobre el papel tapiz, que también
 * cubre la conversación. variante: pagina | burbuja | ancla | aparte -- la burbuja usa la MISMA interfaz que el
 * módulo (ya no una versión «mini» aparte); solo «ancla» (panel angosto anclado al borde) se queda compacta (chips).
 * `menuGlobal`: lo propio de Commandix que NO es de Telegram (separar en ventana, cerrar sesión, tema) -- vive
 * detrás del ☰ de la lista (como el menú de Telegram Web), para que la vista quede igual a la suya. */
export default function TgPanel({ variante = "pagina", onAparte, activa: activaExt, onActiva, menuGlobal }) {
  const t = useTelegram();
  const [local, setLocal] = useState("");
  const [quien, setQuien] = useState(false);
  const [carpeta, setCarpeta] = useState("all");
  const activa = activaExt !== undefined ? activaExt : local;
  const elegir = (id) => (onActiva ? onActiva(id) : setLocal(id));

  const estado = estadoTelegram(t);
  if (estado) return estado;
  const { status, chats } = t;
  const esDueno = status.role === "owner";
  const chat = chats.find((c) => c.chat_id === activa) || null;
  const varLista = variante === "ancla" ? "chips" : "tg";
  const conMenu = variante !== "ancla";
  const multiples = status.role === "employee" && t.compartidos.length > 1;

  return (
    <div className={`tg-panel tg-v-${variante}`} data-testid="tg-panel">
      {multiples && (
        <div className="tg-dueno">
          <label>Cuenta de Telegram
            <select className="tg-in" data-testid="tg-selector-dueno" value={t.owner} onChange={(e) => t.setOwner(e.target.value)}>
              {t.compartidos.map((o) => <option key={o.owner_id} value={o.owner_id}>{o.owner_name}{o.owner_connected ? "" : " (sin conectar)"}</option>)}
            </select>
          </label>
        </div>
      )}
      <div className="tg-cuerpo">
        <TgLista variante={varLista} chats={chats} owner={t.owner} activa={activa} onElegir={elegir} total={t.total}
          carpeta={conMenu ? carpeta : undefined} onCarpeta={conMenu ? setCarpeta : undefined} conteos={t.folderCounts} menu={conMenu ? menuGlobal : null}
          aviso={!esDueno ? "Ves solo los chats que el administrador autorizó" : ""} />
        <div className="tg-der">
          {chat ? (
            <TgConversacion key={`${t.owner}::${chat.chat_id}`} chat={chat} owner={t.owner} esDueno={esDueno} sendEnabled={t.sendEnabled}
              onQuien={esDueno ? () => setQuien(true) : undefined} onAparte={onAparte} onCambioChats={t.refreshChats} compacto={variante === "ancla"} />
          ) : (
            <div className="tg-estado tg-estado-vacio" data-testid="tg-elige">{t.chatsError ? <span role="alert">{t.chatsError}</span> : (chats.length ? null : <span>{t.chatsListos ? "Todavía no hay chats visibles." : "Cargando chats…"}</span>)}</div>
          )}
        </div>
      </div>
      {quien && <QuienVeQue onCerrar={() => { setQuien(false); t.refreshChats(); }} />}
    </div>
  );
}
